<template>
  <div class="user-detail-page">
    <div class="user-detail-card" :style="{ backgroundImage: 'url(' + getback(item?.themeImg) + ')' }">
      <div class="user-detail-card__inner">
        <div class="user-detail-card__top">
          <span class="user-detail-card__no">卡号 {{ item?.cardNo }}</span>
          <span v-if="isUsable" class="user-detail-card__expire">
            {{ $moment(item?.expireDate).format('YYYY.MM.DD') }} 到期
          </span>
        </div>
        <div class="user-detail-card__middle">
          <p class="user-detail-card__name">
            {{ getCardName(item?.cardShowName || item?.cardName) }}
          </p>
          <p class="user-detail-card__point">
            {{ item?.cardRemainingPoint }}<span class="user-detail-card__unit">{{ item?.cardPointTypeUnit }}</span>
          </p>
        </div>
        <div class="user-detail-card__bottom">
          <span v-if="isUsable && ticketType == 'E4' && item?.upgradeFlag == '1'" class="user-detail-card__badge">升级版</span>
          <span v-else></span>
          <div class="user-detail-card__actions">
            <span v-if="isUsable && canUpgrade" :class="actionBtnClass" @click.stop="upgrade">升级</span>
            <span v-if="isUsable" :class="actionBtnClass" @click="goUse">去使用</span>
          </div>
        </div>
      </div>
    </div>

    <div class="user-detail-records">
      <div class="user-detail-records__title">消费记录</div>
      <CardExpendList v-if="item?.cardId" :card-id="item.cardId" />
    </div>
  </div>
</template>

<script>
import { cacheCardInfo } from './index.action';
import { clearCategoryNavCache } from '@/utils/categoryNav';
import CardExpendList from './components/CardExpendList.vue';

export default {
  name: 'UserDetail',
  components: { CardExpendList },
  data() {
    return {
      item: null,
      ticketType: '',
      index: 0,
      imageback: require('@/assets/images/card_bg.svg'),
      imageback2: require('@/assets/images/card_bg2.svg'),
      imageErrorback: require('@/assets/images/card_error_bg.svg'),
      activity: '1',
    };
  },
  computed: {
    isUsable() {
      return this.activity === '1';
    },
    canUpgrade() {
      return this.item?.ifUpgrade == '1' && (this.item?.upgradeFlag == '0' || this.item?.upgradeFlag == '' || !this.item?.upgradeFlag);
    },
    actionBtnClass() {
      return this.getColorType(this.item?.themeImg, this.index) === 1
        ? 'user-detail-card__action user-detail-card__action--warm'
        : 'user-detail-card__action user-detail-card__action--cool';
    },
  },
  mounted() {
    this.item = JSON.parse(localStorage.getItem('itemDetail') || 'null');
    this.ticketType = localStorage.getItem('entrCode') || '';
    this.index = Number(this.$route.query.index) || 0;
    this.activity = this.$route.query.activity || '1';
  },
  methods: {
    upgrade() {
      localStorage.setItem('cardItem', JSON.stringify(this.item));
      this.$router.push({
        path: '/UpdateCard',
        query: { ticketType: localStorage.getItem('entrCode') },
      });
    },
    getCardName(str) {
      if (!str) return '';
      return str.length > 12 ? `${str.substring(0, 12)}…` : str;
    },
    getback(str) {
      if (!this.isUsable) return this.imageErrorback;
      if (str) return str;
      return this.index % 2 === 0 ? this.imageback : this.imageback2;
    },
    getColorType(str, index) {
      if (!str) return index % 2 === 0 ? 1 : 2;
      return 1;
    },
    goUse() {
      if (this.item.cardInitPoint == 0) {
        localStorage.setItem('isPreviewMode', 'true');
      } else {
        localStorage.removeItem('isPreviewMode');
      }
      cacheCardInfo(this.item);
      if (this.item.ifCakeCardEnum == 'CAKE_CARD') {
        this.$router.push({ path: '/CakaHome' });
      } else if (this.item.ifCakeCardEnum == 'MOVIE_CARD') {
        this.$router.push({ path: '/MoviesHome' });
      } else if (this.item.ticketType === 'E6') {
        localStorage.setItem('mallSource', 'giftPackage');
        window.dispatchEvent(new Event('mallSourceChange'));
        this.$router.push({ path: '/GiftPackageHome' });
      } else {
        this.$api
          .isHomeShow({ bathId: this.item.id, upgradeFlag: this.item.upgradeFlag })
          .then((res) => {
            localStorage.setItem('homeShow', res.data ? '1' : '0');
            window.dispatchEvent(new Event('cardChange'));
            if (res.data === true) {
              this.$router.push({ path: '/HomeNew', query: { cardShowFlag: this.item.cardShowFlag } });
            } else {
              clearCategoryNavCache();
              this.$router.push({ path: '/GoodsList', query: { activityId: this.item.id } });
            }
          })
          .catch(() => {
            this.$Toast.fail('此卡不可用');
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-detail-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 0.75rem 1rem 1.5rem;
  box-sizing: border-box;
}

.user-detail-card {
  position: relative;
  height: 11.5rem;
  border-radius: 0.875rem;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.user-detail-card__inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 0.9rem 1rem 1rem;
  box-sizing: border-box;
}

.user-detail-card__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  color: #fdfafa;
  font-size: 0.75rem;
}

.user-detail-card__middle {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 0.75rem;
}

.user-detail-card__name {
  margin: 0;
  color: #fff;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
}

.user-detail-card__point {
  margin: 0;
  color: #fff;
  font-size: 1.25rem;
  font-weight: 700;
  white-space: nowrap;
}

.user-detail-card__unit {
  font-size: 0.8125rem;
  font-weight: 500;
  margin-left: 0.1rem;
}

.user-detail-card__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-detail-card__badge {
  color: #fff;
  font-size: 0.8125rem;
  opacity: 0.95;
}

.user-detail-card__actions {
  display: flex;
  gap: 0.45rem;
  margin-left: auto;
}

.user-detail-card__action {
  min-width: 3.5rem;
  padding: 0.25rem 0.65rem;
  border-radius: 1rem;
  background: #fff;
  font-size: 0.8125rem;
  text-align: center;

  &--warm {
    color: #d59a54;
  }

  &--cool {
    color: #6354ff;
  }
}

.user-detail-records {
  margin-top: 0.875rem;
}

.user-detail-records__title {
  margin-bottom: 0.5rem;
  padding-left: 0.15rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #333;
}
</style>
